import React, { useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ListAltIcon from "@material-ui/icons/ListAlt";
import Tooltip from '@material-ui/core/Tooltip';
import SignalCellularAltIcon from '@material-ui/icons/SignalCellularAlt';
import LocationOnIcon from "@material-ui/icons/LocationOn";
import ReplayIcon from "@material-ui/icons/Replay";
import ShareIcon from '@material-ui/icons/Share';
import {Button, Menu, MenuItem, IconButton, Grid, SwipeableDrawer, Divider, useMediaQuery, useTheme} from "@material-ui/core";
import {WhatsApp, Facebook, LinkedIn, Mail, Message, Send,} from "@material-ui/icons";

import {formatPosition, formatterTimeDuration} from '../common/formatter';
import { t } from '../common/LocalizationProvider'
import { map } from './Map';
import ConfirmHandler from "../shared/ConfirmHandler";
import {devicesSelectedActions} from "../store";
import {cyberStyles} from "../cssShared/cyberTheme";

const useStyles = makeStyles((theme) => ({
    ...cyberStyles(theme),
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    avatar: {
        backgroundColor: red[500],
    },
    iconSocilaMedia: {
        width: 24,
        height: 24,
        objectFit: 'contain',
        display: 'inline-block',
    },
    title: {
        cursor: 'pointer',
        display: 'block',      // Ensures the span takes up space
        maxWidth: '120px',     // Adjust this width based on your preference
        whiteSpace: 'nowrap',  // Prevents text from wrapping to the next line
        overflow: 'hidden',    // Hides the text that overflows
        textOverflow: 'ellipsis' // Adds the "..."
    },
}));

function smoothFlyTo(mapGoogle, targetLatLng, targetZoom, step = 0.5, delay = 50) {
    // Start panning smoothly
    mapGoogle.panTo(targetLatLng);

    const currentZoom = mapGoogle.getZoom();
    const zoomSteps = [];

    // Create zoom steps between current and target
    if (currentZoom < targetZoom) {
        for (let z = currentZoom + step; z <= targetZoom; z += step)
            zoomSteps.push(Number(z.toFixed(1)));
    } else {
        for (let z = currentZoom - step; z >= targetZoom; z -= step)
            zoomSteps.push(Number(z.toFixed(1)));
    }

    let i = 0;
    const interval = setInterval(() => {
        if (i >= zoomSteps.length) {
            clearInterval(interval);
            return;
        }
        mapGoogle.setZoom(zoomSteps[i]);
        i++;
    }, delay);
}

const getStatusColor = (status) => {
    switch (status) {
        case 'online':
            return 'green';
        case 'offline':
            return 'gray';
        case 'slowing':
            return 'yellow';
        default:
            return 'red';
    }
};


const StatusView = ({ history , deviceId, onShowDetails, mapGoogle }) => {

    const device = useSelector(state => state.devices.items[deviceId]);
    const position = useSelector(state => state.positions.items[deviceId]);
    const mapType = useSelector(state => state.session.user && state.session.user.map)
    const dispatch = useDispatch();

    const [selectedAnchorEl, setSelectedAnchorEl] = useState(null);
    const [removeDialogShown, setRemoveDialogShown] = useState(false);
    const [tooltipDetail, showTooltipDetail] = useState(false);
    const [tooltipPlay, showTooltipPlay] = useState(false);
    const [address, setAddress] = useState('address');
    const [anchorEl, setAnchorEl] = useState(null);

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("xs"));


    const classes = useStyles();

    const language = useSelector(state => state.language.language);

    const onMenuClick = (anchorId) => {
        setSelectedAnchorEl(anchorId);
    }
    const menuHide = () => {
        setSelectedAnchorEl(null);
    }
    const handleEdit = () => {
        history.push(`device/${deviceId}`);
        menuHide();
    }
    const handleRemove = () => {
        setRemoveDialogShown(true);
        menuHide();
    }
    const handleRemoveResult = () => {
        setRemoveDialogShown(false);
    }
    const handleCommand = (itemId) => {
        history.push(`command/${itemId}`);
        menuHide();
    }
    const handleClick = e => {
        showTooltipDetail(false)
        e.preventDefault();
        onShowDetails(position.id);
    };

    const onZoom = () => {
        if (mapType === 'googleMap') {
            if (mapGoogle.getZoom() < 8) {
                smoothFlyTo(
                    mapGoogle,
                    { lat: position.latitude, lng: position.longitude },
                    15
                );
            }  else {
                if(map.getZoom() < 8)
                    map.flyTo({
                        center: [position.longitude , position.latitude],
                        zoom: 15 });
                else
                    map.flyTo({
                        center: [position.longitude , position.latitude],
                        zoom: 6 });
            }
        }
        else {
            if(map.getZoom() < 8  )
                map.flyTo({
                    center: [position.longitude , position.latitude],
                    zoom: [15] });
        }
    }

    const signalStrength = position?.attributes?.gpsSgn ?? 0;

    const color = (signal) => {
        if (signal<3)
            return '#C20000';
        else if (signal>=3 && signal<5)
            return '#FFD000'
        else
            return '#00FF00'
    }

    const handeleReplay = () => {
        dispatch(devicesSelectedActions.updateDevicesSelected([device.id]));
        showTooltipPlay(false)
        history.push(`replay/${device.id}`)
    }

    const fetchAddress = async () => {
        fetch(`https://nominatim.openstreetmap.org/reverse?lat=${position.latitude}&lon=${position.longitude}&format=json`, {
            headers: {
                'User-Agent': 'ID of your APP/service/website/etc. v0.1'
            }
        })
            .then(res => res.json())
            .then(res => {
                res.display_name ? setAddress(res.display_name) : setAddress(t('NoAddress'));
            })
    }

    const fetchGoogleAddress = async () => {
        const latitude = position.latitude;
        const longitude = position.longitude;

        if (!window.google || !window.google.maps || !latitude || !longitude) return;
        try {
            const response = await fetch(`/api/googleAddress?lat=${latitude}&lng=${longitude}`);
            const data = await response.json();
            if (data && data.Address)
                setAddress(data.Address);
            else
                setAddress(t("NoAddress"))
        } catch (error) {
            console.error("Secure Geocoding failed", error);
            setAddress(t("errorMessage"))
        }
    }

    const handleGetAddress = () => {
        if (address === 'address' || address === t('NoAddress')){
            if (mapType === 'googleMap')
                fetchGoogleAddress();
            else
               fetchAddress();
        }
    }

    const socialMediaPlatforms = [
        { name: "WhatsApp", icon: <WhatsApp style={{ color: "#25D366" }} /> },
        { name: "Facebook", icon: <Facebook style={{ color: "#1877F2" }} /> },
        { name: "Messanger", icon: <img className={classes.iconSocilaMedia} src={`images/socialMedia/messanger.webp`} alt=""/> },
        { name: "Telegram", icon: <Send style={{ color: "#0088CC" }} /> },
        { name: "LinkedIn", icon: <LinkedIn style={{ color: "#0077B5" }} /> },
        { name: "Viber", icon: <img className={classes.iconSocilaMedia} src={`images/socialMedia/viber.png`} alt=""/>},
        { name: "Email", icon: <Mail style={{ color: "#D44638" }} /> },
        { name: "Messages", icon: <Message style={{ color: "#34C759" }} />},
    ];

    const handleShare = (name) => {
        const { latitude, longitude, speed } = position;
        const deviceName = device.name;
        const url = `https://www.google.com/maps?q=${latitude},${longitude}&z=18`; // z=18 is a zoom level
        const text = `📍 Device: ${deviceName}\n 📍 IMEI: ${device.uniqueId}\n🚀 Speed: ${speed} km/h\n🌍 Location: ${latitude}, ${longitude}\n🗺️ Map: ${url}`;

        if (name === 'WhatsApp') {
            const shareUrl = `https://wa.me/?text=${encodeURIComponent(text)}`;
            window.open(shareUrl, "_blank");
        }
        else if (name === 'Facebook') {
            // const url = `https://tracthing.com`;
            const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
            window.open(shareUrl, '_blank');
        }
        else if (name === 'Messanger') {
            const messengerUrl = `fb-messenger://share?link=${encodeURIComponent(url)}`;
            window.open(messengerUrl, '_blank');
        }
        else if (name === 'Telegram') {
            const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(text)}`;
            window.open(shareUrl, "_blank");
        }
        else if (name === 'LinkedIn') {
            const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(text)}`;
            window.open(shareUrl, '_blank');
        }
        else if (name === 'Twitter') {
            const hashtags = 'devices,report';
            const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}&hashtags=${hashtags}`;
            window.open(twitterUrl, '_blank');
        }
        else if (name === 'Viber') {
            const viberUrl = `viber://forward?text=${encodeURIComponent(text)}`;
            window.location.href = viberUrl;
        }
        else if (name === 'Email') {
            const subject = `Device Report: ${deviceName}`;
            const body = `Hi,\n\nCheck out this device report:\n${text}`;
            const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
            window.location.href = mailtoLink;
        }
        else{
            const smsLink = `sms:?&body=${encodeURIComponent(text)}`;
            window.location.href = smsLink;
        }
        setAnchorEl(null);
    };

    const mediaIcons = () => {
        if (!isSmallScreen)
            return (
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                    classes={{ paper: classes.menuPaper }}
                    style={{ width: 200 }}
                    elevation={0}
                >
                    {socialMediaPlatforms.map((platform, index) => (
                        <MenuItem
                            key={index}
                            onClick={() => handleShare(platform.name)}
                            className={classes.menuItem}
                        >
                            <IconButton size="small">{platform.icon}</IconButton>
                            <span style={{ marginLeft: 8 }}>{platform.name}</span>
                        </MenuItem>
                    ))}
                </Menu>
            );
        else
            return(
                <SwipeableDrawer
                    anchor="bottom"
                    open={Boolean(anchorEl)}
                    onOpen={(event) => setAnchorEl(event.currentTarget)}
                    onClose={() => setAnchorEl(null)}
                    classes={{ paper: classes.paperSocialMedia }}
                    PaperProps={{
                        style: {
                            borderTopLeftRadius: 16,
                            borderTopRightRadius: 16,
                            height: "50vh",
                        },
                    }}
                >
                    <div style={{ padding: 16 }}>
                        <Typography variant="h6" align="center" style={{ color: '#00f2ff' }}>
                            {t('share')}
                        </Typography>
                        <Divider style={{ marginBottom: 16, backgroundColor: '#00f2ff', boxShadow: '0 0 8px #00f2ff' }} />
                        <Grid container spacing={3} justifyContent="center">
                            {socialMediaPlatforms.map((platform, index) => (
                                <Grid item xs={3} key={index} style={{ textAlign: "center" }}>
                                    <IconButton className={classes.iconMobile} onClick={() => handleShare(platform.name)}>
                                        {platform.icon}
                                    </IconButton>
                                    <Typography className={classes.textMobile}>
                                        {platform.name}
                                    </Typography>
                                </Grid>
                            ))}
                        </Grid>
                        <Button
                            fullWidth
                            variant="outlined"
                            className={`${classes.cyberButtonRemoveDialog} ${classes.saveButtonRemoveDialog}`}
                            style={{ marginTop: 20 }}
                            onClick={() => setAnchorEl(null)}
                        >
                            {t('sharedCancel')}
                        </Button>
                    </div>
                </SwipeableDrawer>
            );
    };

    return (
        <>
            {device && position &&
                <Card className={classes.statusCard}>
                    <CardHeader
                        avatar={
                            <Avatar aria-label="recipe" style={{"backgroundColor": getStatusColor(device.status)}}>
                                <img className={classes.icon} src={`images/icon/${device.category || 'default'}.svg`} alt=""/>
                            </Avatar>
                        }
                        title={
                            <Tooltip title={device.name} placement="top" arrow>
                            <span className={classes.title}>
                                {device.name}
                            </span>
                            </Tooltip>
                        }
                        subheader={device.uniqueId}
                        style={{"backgroundColor": getStatusColor(device.status), padding: '22px 22px'}}
                        action={
                            <Tooltip title={signalStrength} placement="top" arrow>
                                <SignalCellularAltIcon
                                    style={{
                                        fontSize: 16,
                                        verticalAlign: 'middle',
                                        color: color(signalStrength),
                                        transform: 'scale(2)',
                                        marginTop: -2,
                                    }}
                                />
                            </Tooltip>
                        }
                    />
                    <CardContent className={classes.statusCardContent}>
                        {position &&
                            <Typography
                                className={classes.cancelButtonRemoveDialog}
                                variant="body2"
                                color="textSecondary"
                                component="p"
                                dir={language === 'ar' || language === 'fa' ? 'rtl' : 'ltr'}>
                                <b>{t('deviceStatus')}:</b> {t(formatPosition(device.status, 'status').toLowerCase())} ({formatterTimeDuration(position, device)})<br/>
                                <b>{t('sharedLocation')}:</b> {formatPosition(position, 'latitude')} {formatPosition(position, 'longitude')}<br/>
                                <b>{t('Lastpositioning')}:</b> {formatPosition(position.fixTime, 'fixTime')}<br/>
                                <b>{t('obd2Status')}:</b> {t(formatPosition(position.attributes.obd2Status, 'obd2Status') + 'OBDII')}<br/>
                                {position.attributes.obd2Status === 'ON' &&
                                    <><b>{t('positionRpm')}:</b> {formatPosition(position.attributes.rpm, 'rpm')}<br/></>}
                                {position.attributes.tanklevelSensor !== 'OFF' &&
                                    <>
                                        <b>{t('positionTanklevel')}:</b> {formatPosition(position.attributes.tanklevel, 'tanklevel')}<br/></>}
                                <b>{t('positionAddress')}: </b>
                                <a onClick={handleGetAddress} style={{color: 'blue', textDecoration: 'underline', cursor: 'pointer'}}>
                                    {address}
                                </a><br/>
                            </Typography>}
                    </CardContent>

                    <Grid container style={{ padding: '0 16px 8px 16px', alignItems: 'center' }}>
                        <Grid item xs>
                            <Tooltip
                                title={t("detail")}
                                open={tooltipDetail}
                                onOpen={() => showTooltipDetail(true)}
                                onClose={() => showTooltipDetail(false)}
                            >
                                <IconButton
                                    className={classes.moreIcon}
                                    onClick={handleClick}
                                    aria-label={t("detail")}>
                                    <ListAltIcon style={{ fontSize: 20 }}/>
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item xs>
                            <Tooltip title="Zoom">
                                <IconButton
                                    className={classes.moreIcon}
                                    onClick={onZoom}
                                    aria-label={t("tracking")}>
                                    <LocationOnIcon style={{ fontSize: 20 }}/>
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item xs>
                            <Tooltip title={t("share")}>
                                <IconButton
                                    className={classes.moreIcon}
                                    onClick={(event) => setAnchorEl(event.currentTarget)}
                                    aria-label={t("share")}>
                                    <ShareIcon style={{ fontSize: 20 }}/>
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        {mediaIcons()}
                        <Grid item xs>
                            <Tooltip
                                title={t("playback")}
                                open={tooltipPlay}
                                onOpen={() => showTooltipPlay(true)}
                                onClose={() => showTooltipPlay(false)}
                            >
                                <IconButton
                                    className={classes.moreIcon}
                                    onClick={handeleReplay}
                                    aria-label={t("playback")}>
                                    <ReplayIcon style={{ fontSize: 20 }}/>
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item xs>
                            <Tooltip title={t("actions")}>
                                <IconButton
                                    className={classes.moreIcon}
                                    onClick={(event) => onMenuClick(event.currentTarget)}>
                                    <MoreVertIcon style={{ fontSize: 20 }}/>
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Menu
                            open={!!selectedAnchorEl}
                            anchorEl={selectedAnchorEl}
                            onClose={menuHide}
                            className={classes.menu}
                        >
                            <MenuItem className={classes.menuItem} onClick={handleEdit}>{t('sharedEdit')}</MenuItem>
                            <MenuItem className={classes.menuItem} onClick={handleRemove}>{t('sharedRemove')}</MenuItem>
                            <MenuItem className={classes.menuItem} onClick={() => handleCommand(deviceId)}>{t('commands')}</MenuItem>
                        </Menu>
                    </Grid>
                </Card>
            }
            <ConfirmHandler open={removeDialogShown} endpoint="devices" itemId={deviceId} handleCloseDialog={handleRemoveResult} />
        </>
    );
};

export default StatusView;